<template>
    <v-dialog v-model="openDialog" max-width="800px" persistent transition="scale-transition" max-height="600px">
      <v-card style="overflow:hidden;display:block;">
        <v-layout v-if="item" id="resource-modal">
          <v-flex xs12 md12 class="resource-main" style="height:600px; overflow-y: scroll">
              <v-layout column class="secondary">
                <v-flex xs12>
                  <v-btn dark @click.prevent="cancel()" icon>
                    <v-icon color="white">close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="resource_content">
                <v-flex xs12>
                  <div class="resource-details-actions secondary">
                    <h2 class="py-4 px-4 resource-title text-sm-center white--text">{{item.title}}</h2>
                    <v-layout row wrap px-4 pb-3>
                      <v-flex pt-1 xs12 sm4 class="text-xs-center white--text">
                        <v-icon color="white">access_time</v-icon>
                        <span>{{item.submitdate | actualDate}}</span>
                      </v-flex>
                      <v-flex pt-1 sm4 justify-center class="white--text" >
                        <v-icon color="white">list_alt</v-icon>
                        <span>{{item.category}}</span>
                      </v-flex>
                      <v-flex pt-1 sm4 justify-center class="white--text">
                        <v-icon color="white" style="font-size:16px">fa-tags</v-icon>
                        <span v-for="(tag, index) in item.tags" :key="index">{{tag}}<span v-if="index+1 < item.tags.length">,</span></span>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div class="pt-2 post_img resource-media">
                    <iframe v-if="item.media.id" :src="item.media.embedUrl" allowfullscreen></iframe>
                    <img v-else :src="item.media " alt="Agency Logo">
                  </div>
                  <div class="px-4 py-4 description resource-text" v-html="item.content">
                  </div>
                  <v-layout>
                    <v-card-actions dark style="position: relative; bottom: 25px;width:100%">
                      <v-layout class="mt-1 pt-1 mx-4 text-xs-center" justify-space-around>
                        <!-- <v-btn flat><v-icon medium>mdi-heart</v-icon></v-btn> -->
                        <div class="flex">
                          <v-btn v-if="!favorited" style="width:100%" small secondary--text flat slot="activator" @click.prevent="favoriteItem">
                            <v-layout column align-center style="font-size:10px;">
                              <v-icon medium class="secondary--text">favorite</v-icon>
                            </v-layout>
                          </v-btn>

                          <v-btn v-else style="width:100%" small flat slot="activator" @click.prevent="unfavoriteItem">
                            <v-layout column align-center style="font-size:10px;">
                              <v-icon medium color="red">favorite</v-icon>
                            </v-layout>
                          </v-btn>
                        </div>

                        <div class="flex" >
                          <share-button color="secondary" :link="link"></share-button>
                        </div>
                      </v-layout>
                    </v-card-actions>
                  </v-layout>
                </v-flex>
              </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

</template>

<style scoped>
.group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -ms-flex-pack: distribute;
  justify-content: space-around;
}
.tabs__wrapper {
  overflow: hidden;
}
.vue-highcharts {
  border: none;
  box-shadow:none;
}
.tabs__content {
  height: 500px;
  overflow-x:hidden;
  overflow-y: scroll;
}
  .resource_post_details{
    padding-top:220px;
  }
  .resource_post_details strong,
  .resource_post_details span
  {
    color:#fff;
    font-size: 16px;
  }
  .resource_content h2{
    font-size: 28px;
    color: #000;
    line-height: 32px;
    font-weight: 600;
  }

  .resource_content p{
    margin-bottom: 0;
    font-size: 18px;
    color: #666;
  }
  .post_img{
    height: 300px;
    line-height: 300px;
    width: 100%;
    text-align: center;
  }
  .post_img img{
      max-height: 300px;
      width: auto;
    display: inline-block;
    vertical-align: middle;
    line-height: normal;
  }
  .post_img iframe{
    min-height: 300px;
    width: 100%;
    border: none;
  }
</style>


<script>
import ShareButton from '../../../components/ShareButton.vue'
import moment from 'moment'
import Vue from 'vue'

Vue.filter('formatDateTime', function (value) {
    if (value) {
      return moment(value).format('MMMM DD, YYYY')
    }
  })

export default {
  components: {
    ShareButton,
  },
  props: ['dialog', 'item'],
  data () {
    return {
      openModal: false,
      favorited: false,
    }
  },
  watch: {
    openModal (val) {
    },
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    favoriteItem () {
      let favoritePayload = {
        [this.item.id]: this.item.id
      }
      this.$firebase.database().ref(`favorites/resources/${this.user.uid}/${this.item.id}`).set(favoritePayload)
    },
    unfavoriteItem () {
      console.log('clicked')
      this.$firebase.database().ref(`favorites/resources/${this.user.uid}/${this.item.id}`).set(null)
    },
    isFavourited () {
        var self = this
        this.$firebase.database()
        .ref(`favorites/resources/${this.user.uid}/${this.item.id}`)
        .on('value', function(snapshot) {
            if (!snapshot.val()) {
                self.favorited = false
            } else {
                self.favorited = true
            }
        })
    }
  },
  computed: {
    breakpoint () {
      return this.$vuetify.breakpoint.name
    },
    htmlContent(){
        return this.item.content
    },
    openDialog () {
      this.openModal = this.dialog
      if (this.openModal === true) {
        this.isFavourited()
      }
      return this.dialog
    },
    user () {
        return this.$store.getters.getUserDetails
    },
    screenWidth () {
      return this.$vuetify.breakpoint.width
    },
    styles () {
      return this.$store.getters.getStyles
    },
    userDetails () {
      return this.$store.getters.getUserDetails
    },
    shareLink () {
      return window.location
    },
    link () {
      return `https://${window.location.host}/resources#id=${this.item.id}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// resourceViewModal.vue?42ace1ba